import { render, staticRenderFns } from "./AdminPanelYoutvList.vue?vue&type=template&id=e0c5ba36&"
import script from "./AdminPanelYoutvList.vue?vue&type=script&lang=js&"
export * from "./AdminPanelYoutvList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports